import type { SVGProps } from 'react';

export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} fill="none" height="74" viewBox="0 0 74 74" width="74" xmlns="http://www.w3.org/2000/svg">
      <circle cx="37" cy="37" fill="#00E889" r="37" />
      <path d="M16 39.0682L28.5568 51.625L56.1818 24" stroke="#022E4A" strokeLinecap="round" strokeWidth="4" />
    </svg>
  );
}
